<template>
  <router-link :to="{path: '/CourseDetails', query: courseItem}" target="_blank" class="course-item-mini">
    <div class="course-pic">
      <img class="coursePic" :src="courseItem.logoPath" alt="易极云课堂">
    </div>
    <p class="name">{{ courseItem.name }}</p>
    <span class="money" v-if="courseItem.currentPrice!==0">{{ courseItem.currentPrice }}</span>
    <span class="money" v-else>免费</span>
    <span class="number">{{ courseItem.saleNum }}</span>
  </router-link>
</template>

<script>
export default {
  props: {
    courseItem: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
  @import '~@/styles/base.scss';
  .course-item-mini {
    position: relative;
    display: block;
    height: 170px;
    width: 160px;
    // box-shadow: 0 2px 4px #eee;
    .course-pic {
      height: 80px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .name {
      margin: 22px 0 10px 0;
      font-size: 14px;
      color: #333;
    }
    .money {
      float: left;
      color: #999;
      letter-spacing: 0;
      font-size: 12px;
      &:before {
        content: '￥';
      }
    }
    .number {
      float: right;
      color: #9F9FA0;
      font-size: 10px;
      position: relative;
      letter-spacing: 0;
      font-size: 14px;
      // &::before {
      //   position: absolute;
      //   content: url("./peopleIcon.png");
      //   left: -14px;
      //   top: 1px;
      // }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/course-item-mini/course-item-mini.vue